import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import RPOData from '../components/sections/RPO'

const RPO = () => (
  <>
    <div id='smooth-wrapper'>
      <div id='smooth-content'>
        <div className='podio rpo-wrapper'>
          <RPOData />
          <Footer />
        </div>
      </div>
    </div>
    <Header />
  </>
)

export default RPO
